import React from 'react';
import { compose } from 'ramda';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import { withEditModeNotice } from '_containers/BaseComponent';
import asyncComponent from '_containers/AsyncComponent';
import { Link } from '_utils/components/Corporate';

import { ContentListItemProps } from './definitions';
import {
  ContentListItem as StyledContentListItem,
  IconWrapper,
  ContentListItemTitle,
  ContentListItemDesc,
  ContentListItemLinkWrapper,
  LinkWrapper,
  List,
  ListItem,
  LinkItem,
  EditorDiv
} from './StyledGroupedContentList';

const EditorText = compose(withEditModeNotice)(EditorDiv);

const ContentListItem: React.FC<ContentListItemProps> = ({
  icon,
  footerLink,
  cardTheme,
  title,
  description,
  links,
  headingLevel,
  editMode
}) => {
  const Icon = icon?.fields?.displayName?.value
    ? asyncComponent(() => import(`_utils/icons/GroupedContent/${icon.fields.displayName.value}`))
    : null;

  const level = `h${headingLevel === 7 ? 6 : headingLevel}`;

  const footLink = (
    <ContentListItemLinkWrapper>
      <Link field={footerLink} description={footerLink?.value?.text} linkSize="s" />
    </ContentListItemLinkWrapper>
  );

  return (
    <StyledContentListItem $cardTheme={cardTheme}>
      <EditorText
        noticeEnabled
        noticeLevel="info"
        noticeMessage={`To configure the icon for this card, please use the 'Edit related items' screen.`}
      >
        {Icon && (
          <IconWrapper>
            <Icon />
          </IconWrapper>
        )}
      </EditorText>
      <ContentListItemTitle as={level}>
        <Text field={title} />
      </ContentListItemTitle>
      <ContentListItemDesc>
        <Text field={description} />
      </ContentListItemDesc>
      <LinkWrapper>
        {links.length > 0 && (
          <List>
            {links.map((l, k) => (
              <ListItem key={k}>
                <LinkItem
                  description={l?.value?.text}
                  field={l}
                  linkTheme="secondary"
                  linkSize="s"
                />
              </ListItem>
            ))}
          </List>
        )}
      </LinkWrapper>
      {editMode ? footLink : footerLink.value.href !== '' && footLink}
    </StyledContentListItem>
  );
};

export default ContentListItem;
